import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WindowTypes } from './components/WindowTypes';
import { ExpertSection } from './components/ExpertSection';
import { WhatsAppDiagnostic } from './components/WhatsAppDiagnostic';
import { Portfolio } from './components/Portfolio';
import { About } from './components/About';
import { TeamBanner } from './components/TeamBanner';
import { SEOContent } from './components/SEOContent';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { ServiceAreas } from './components/ServiceAreas';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    document.title = "Réparation Fenêtres Bordeaux | Expert PVC Alu Bois | Baies Vitrées";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert réparation fenêtres Bordeaux et Gironde ✓ PVC, Aluminium, Bois ✓ Baies vitrées ✓ Volets roulants ✓ Intervention rapide ✓ Devis gratuit ✓ 15 ans d\'expérience');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Bordeaux, fenêtres PVC, fenêtres aluminium, baies vitrées, volets roulants');
    }

    // Open Graph tags
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://reparation-fenetre-bordeaux.fr/');
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Réparation Fenêtres Bordeaux | Expert PVC Alu Bois | Baies Vitrées');
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Expert réparation fenêtres Bordeaux et Gironde ✓ PVC, Aluminium, Bois ✓ Baies vitrées ✓ Volets roulants ✓ Intervention rapide ✓ Devis gratuit ✓ 15 ans d\'expérience');
    }

    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      ogImage.setAttribute('content', 'https://public.readdy.ai/ai/img_res/d8dbc6eecddcea582fa595ac9d1cd3a9.jpg');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <WindowTypes />
      <ExpertSection />
      <ServiceAreas />
      <Portfolio />
      <TeamBanner />
      <FAQ />
      <SEOContent />
      <WhatsAppDiagnostic />
      <Contact />
      <Footer />
    </div>
  );
}
